import { ParsedUrlQuery } from 'querystring';
import type DistanceAway from '@alltrails/explore-service/types/DistanceAway';
import type { TrailTraffic } from '@alltrails/trails';
import trailTrafficToVisitorUsage from '@alltrails/trails/src/utils/trailTrafficToVisitorUsage';

export const bottomRightLatParamKey = 'b_br_lat';
export const bottomRightLngParamKey = 'b_br_lng';
export const topLeftLatParamKey = 'b_tl_lat';
export const topLeftLngParamKey = 'b_tl_lng';

export const latParamKey = 'lat';
export const lngParamKey = 'lng';

// Suitability and feature uses the same param key since they used to be the same filter in the monolith
export const distanceAwayParamKey = 'da';
export const activityParamKey = 'a[]';
export const difficultyParamKey = 'diff[]';
export const lengthParamKey = 'length[]';
export const durationParamKey = 'duration[]';
export const elevationGainParamKey = 'elev[]';
export const suitabilityParamKey = 'f[]';
export const featureParamKey = 'f[]';
export const routeTypeParamKey = 'route[]';
export const minRatingParamKey = 'rating_min';
export const trailTrafficParamKey = 'usage[]';
export const highestPointParamKey = 'highest_point[]';
export const trailEngagementParamKey = 'c[]';

export const adminClosedParamKey = 'closed';
export const adminAreaParamKey = 'area[]';
export const adminCityParamKey = 'city[]';
export const adminCountryParamKey = 'country[]';
export const adminStateParamKey = 'state[]';

// Matches to keys in @alltrails/search/utils/getNaturalLanguageSearchUrl.ts
export const naturalLanguageQueryParamKey = 'nlq';
export const naturalLanguageClickPositionParamKey = 'nlcp';
export const naturalLanguageSelectionTypeParamKey = 'nlst';
export const naturalLanguageSelectionMethodParamKey = 'nlsm';
export const naturalLanguageSearchOriginParamKey = 'nlso';

export const sortParamKey = 'sort';

export const createDistanceAwayParamString = (distanceAway: DistanceAway) =>
  [distanceAway.center.lng, distanceAway.center.lat, distanceAway.distance].join('_');
export const parseDistanceAwayParamString = (distanceAwayParamString): DistanceAway => {
  const [lng, lat, meters] = distanceAwayParamString.split('_').map(str => Number(str));
  return {
    center: { lat, lng },
    distance: meters
  };
};

export const updateSearchParamsWithLatLng = (searchParams: ParsedUrlQuery, latLng?: { lat: number; lng: number }) => {
  if (latLng) {
    return {
      ...searchParams,
      [latParamKey]: String(latLng.lat),
      [lngParamKey]: String(latLng.lng)
    };
  }
  return searchParams;
};

// This intentionally only includes the values that are displayed to users
export const trailTrafficParamValues: Record<TrailTraffic, string> = {
  light: trailTrafficToVisitorUsage['light'].toString(),
  moderate: trailTrafficToVisitorUsage['moderate'].toString(),
  heavy: trailTrafficToVisitorUsage['heavy'].toString()
};
